import { render, staticRenderFns } from "./PalletsPage.vue?vue&type=template&id=33e7c3f6&"
import script from "./PalletsPage.vue?vue&type=script&lang=js&"
export * from "./PalletsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports